import React from 'react'
import styled from '@emotion/styled'
import {Color} from '../../../Styles'
import {ColumnFlexContainer, FlexContainer} from '../../../Atoms/Containers'
import {MBCvsReadyBadge} from '../../../Atoms/Badges'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {PageUrlInfo} from '../../../../Models/Types'
import {MBMemberError} from '../../../../Common/MBMemberError'
import {MemberArrowRightIcon} from '../../../Atoms/Icons/MemberArrowRightIcon'

const BucketLink = styled.a`
  color: ${Color.Grey800};
  padding: 23px 10px;
  cursor: pointer;
  display: block;
  position: relative;
`

type BucketLinkButtonProps = {
  pageUrlInfo: PageUrlInfo
}

export const BucketLinkButton: React.VFC<BucketLinkButtonProps> = ({pageUrlInfo}) => {
  if (!pageUrlInfo.url) {
    throw new MBMemberError('SystemError')
  }

  return (
    <BucketLink href={pageUrlInfo.url}>
      <FlexContainer alignItems={'center'} gap={'23px'}>
        <ColumnFlexContainer alignItems={'flex-start'} gap={'4px'}>
          <SignedUpStatusBadge signedUpStates={pageUrlInfo.signedUpStates}/>
          <div>{pageUrlInfo.name}</div>
        </ColumnFlexContainer>
        <Spacer ml={'auto'}>
          <MemberArrowRightIcon/>
        </Spacer>
      </FlexContainer>
    </BucketLink>
  )
}

type  StatusBudgesProps = Pick<PageUrlInfo, 'signedUpStates'>
const SignedUpStatusBadge: React.VFC<StatusBudgesProps> = (props) =>
  props.signedUpStates?.includes('convenience_store_ready') ? <MBCvsReadyBadge/> : null
